// extracted by mini-css-extract-plugin
module.exports = {"telFax":"TelFax_telFax__hKBam"};